var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScotiabankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 213.000000 236.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,236.000000) scale(0.100000,-0.100000)",
    fill: "#ee3224",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875 2350 c-72 -10 -161 -38 -220 -67 -354 -178 -506 -581 -358 -951 l26 -64 23 91 c53 211 195 389 388 484 141 70 147 70 596 77 l404 5 173 190 c95 105 183 202 194 218 l20 27 -598 -1 c-329 -1 -621 -5 -648 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 1754 c-205 -54 -364 -210 -426 -419 -24 -81 -24 -229 0 -310 59 -197 202 -346 396 -411 85 -29 273 -27 363 5 184 63 325 214 383 407 24 79 24 228 0 309 -62 210 -224 368 -431 420 -74 19 -212 18 -285 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787 1010 c-49 -215 -203 -402 -413 -501 -135 -64 -176 -69 -602 -70 l-377 0 -170 -190 c-93 -104 -181 -203 -194 -220 l-24 -30 634 3 c625 4 635 4 709 27 272 82 468 293 524 563 30 145 14 307 -43 432 l-27 61 -17 -75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScotiabankIcon);
export default __webpack_public_path__ + "static/media/scotiabank-icon.4472f43d3e0bd5a76a7aa9a38df680f8.svg";
export { ForwardRef as ReactComponent };